export default __webpack_public_path__ + "static/media/Contactbanner.040819b1.png";